import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  getCompanies(config) {
    return axiosInstance.get('/master/company', {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  getCompanyById(id, config) {
    return axiosInstance.get(`/master/company/${id}`, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  getCompanyByName(param) {
    return axiosInstance.get('/master/company', {
      params: param,
      cancelToken: getNewCancelToken(),
    });
  },
  getCompany(params) {
    return axiosInstance.get('/master/company', {
      params,
      cancelToken: getNewCancelToken(),
    });
  },
  getCompanyByGroupId(param) {
    return axiosInstance.get(`/master/company?findField=${param.findField}&findValue=${param.findValue}`, {
      cancelToken: getNewCancelToken(),
    });
  },
  addCompany(data) {
    return axiosInstance.post('/master/company', data, {
      cancelToken: getNewCancelToken(),
    });
  },
  updateCompany(id, data) {
    return axiosInstance.put(`/master/company/${id}`, data, {
      cancelToken: getNewCancelToken(),
    });
  },
  deleteCompany(id) {
    return axiosInstance.delete(`/master/company/${id}`, {
      cancelToken: getNewCancelToken(),
    });
  },
};
